import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1d0f47bb"
import script from "./Index.vue?vue&type=script&setup=true&lang=ts"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports